import { Label } from '@/components/ui/label';
import { Calendar, PlusCircle } from 'lucide-react';
import Link from 'next/link';
import React from 'react';

const CTA = (): React.ReactNode => {
  return (
    <div>
      <div className='w-full bg-gray-800'>
        <div className='mx-auto max-w-7xl py-6 px-4 lg:px-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4'>
          <div className='flex items-center justify-start gap-4'>
            <Calendar
              strokeWidth={1.5}
              aria-hidden='true'
              className='w-12 h-12 shrink-0 rounded-md border-2 border-zinc-700 bg-zinc-900 p-2 text-white '
            />
            <div className='flex flex-col'>
              <Label className='text-lg md:text-xl font-bold tracking-wide text-white'>
                List your Event
              </Label>
              <Label className='text-xs/7 font-semibold text-white/80 leading-4'>
                Got an event, activity or a great experience? Partner with us & get listed on Greet
              </Label>
            </div>
          </div>

          <div className='w-full md:w-fit flex items-center gap-x-6 shrink-0'>
            <Link
              href='/organizer'
              className='w-full relative flex cursor-pointer justify-center items-center gap-2 rounded-md bg-gradient-to-tr from-[#fe3838] to-[#e33737] px-6 py-2 font-semibold text-white transition-colors hover:from-[#af2626]'
            >
              <div className='relative z-10 flex gap-1'>
                <PlusCircle aria-hidden='true' className='size-6' />{' '}
                <Label className='cursor-pointer text-xs font-bold'>
                  {' '}
                  CREATE EVENT
                </Label>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CTA;
